import { useEffect, useState } from 'react';
import { useDrawer } from '../../../../shared/drawer';
import { useNavigate } from 'react-router-dom';
import { Table } from "../../../../elements/table";
import { PageBody } from '../../../../elements/page-body';
import { useStore } from '../../../../shared/store';
import { ItvTabForm } from './itv-tab-form';
import { ControlKmTabForm } from './control-km-tab-form';




export const ControlKmTab = ({
    item,
    onAction
}: {
    item?: any;
    onAction: () => void;
}) => {
    const { open, close } = useDrawer();
    const { get, set } = useStore();
    const navigate = useNavigate();
    const [refresh, setRefresh] = useState<string | null>(null);


    const handleClose = () => {
        setRefresh(Date.now().toString());
        onAction();
        close();
        window.location.reload();
    };

    const handleNewAction = () => {
        open('common.form-title.new', <ControlKmTabForm close={handleClose} vehicleId={item} />);
    };



    return (
        <>

            <PageBody
                newAction={handleNewAction}
                newActionTitle={'common.form-title.new'}
                title={'common.label.control-km'}
            //titleStatus={'OK'}

            >
                <Table
                    path={`/fleet/mileage-checks/?vehicle=${item}&`}
                    deletePath={`/fleet/mileage-checks/`}
                    callBeforeDrawerClosed={handleClose}
                    Form={ControlKmTabForm}
                    withPagination
                    refresh={refresh}
                    headers={[
                        {
                            key: 'date',
                            type: 'date',
                            label: 'common.label.fecha-control',
                        },
                        {
                            key: 'mileage',
                            label: 'common.label.km-control',
                        },
                        {
                            key: 'observations',
                            label: 'common.label.observaciones',
                        },
                        {
                            key: 'status',
                            type: 'status',
                            label: 'common.label.estado',
                        },
                    ]}
                />
            </PageBody>
        </>

    );
};